import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SideNav from '@/components/feature/SideNav';
import RightRail from '@/components/feature/RightRail';
import type { ReactNode } from 'react';

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="mx-auto w-full max-w-[1400px] flex-1 px-4 py-6 md:px-6 md:py-8">{children}</main>
      <SiteFooter />
    </div>
  );
}

export function PortalShell({
  children,
  showRail = true,
}: {
  children: ReactNode;
  showRail?: boolean;
}) {
  return (
    <div className="flex flex-col gap-6 lg:flex-row">
      <SideNav />
      <div className="min-w-0 flex-1">{children}</div>
      {showRail && (
        <div className="hidden xl:block">
          <RightRail />
        </div>
      )}
    </div>
  );
}

export function Breadcrumb({ items }: { items: { label: string; to?: string }[] }) {
  return (
    <nav aria-label="面包屑导航" className="mb-4 flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
      <Link to="/" className="flex items-center gap-1 transition hover:text-primary-700">
        <i className="ri-home-4-line w-3.5 h-3.5 flex items-center justify-center" />
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line w-3.5 h-3.5 flex items-center justify-center text-foreground-300" />
          {item.to ? (
            <Link to={item.to} className="transition hover:text-primary-700">{item.label}</Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}